<template>
  <v-layout justify-center align-content-center fill-height column>
    <span @click="$emit('openDialog')">
      <h2 class="text-xs-center font-weight-regular">
        Selecione uma sala
      </h2>
    </span>
  </v-layout>
</template>

<script>
export default {
  name: 'PageSelectClassroom'
}
</script>
